module.exports = __webpack_public_path__ + "static/xiaozhou-95031fddf959530e08a58e50bc69adef.jpg";